"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOneTrust = void 0;

var _react = require("react");

var cookiePolicyId = 'optanon-cookie-policy';
/**
 * OneTrust react hook to add the OneTrust script to the app.
 * 
 * @param {string} dataDomainScript The unique OneTrust data domain script string for the domain.
 * @param {string} locale The locale of the app.
 * @param {string} view The current page/view of the app.
 * @param {string} webview Whether the app is in a webview or not.
 * 
 */

var useOneTrust = function useOneTrust(_ref) {
  var dataDomainScript = _ref.dataDomainScript,
      locale = _ref.locale,
      view = _ref.view,
      webview = _ref.webview;

  /**
   * Adds the OneTrust script to the head of the document.
   */
  var addOneTrustScript = function addOneTrustScript() {
    var exemptLocales = ['ko-KR', 'ja-JP'];
    var isValidLocale = !exemptLocales.includes(locale);
    var isJapaneseAndLoginPage = locale === 'ja-JP' && view === '/login';

    if (!document.getElementById('onetrust_js') && !webview && (isValidLocale || isJapaneseAndLoginPage) && dataDomainScript && window) {
      window.OptanonWrapper = function () {}; // Set html lang attribute to locale's language for OneTrust to read.


      document.querySelector('html').setAttribute('lang', locale); // Set geolcation region so CookiePro can use the right template.

      window.OneTrust = {
        geolocationResponse: {
          countryCode: locale.slice(-2).toUpperCase()
        }
      }; // Add cookie policy div to app for OneTrust to populate.

      if (!document.getElementById(cookiePolicyId)) {
        var cookiePolicyHolder = document.createElement('div');
        cookiePolicyHolder.setAttribute('id', cookiePolicyId);
        cookiePolicyHolder.style.display = 'none';
        document.body.appendChild(cookiePolicyHolder);
      }

      var oneTrustScript = document.createElement('script');
      oneTrustScript.setAttribute('id', 'onetrust_js');
      oneTrustScript.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
      oneTrustScript.setAttribute('type', 'text/javascript');
      oneTrustScript.setAttribute('data-document-language', 'true');
      oneTrustScript.setAttribute('data-domain-script', dataDomainScript);
      document.head.appendChild(oneTrustScript);
    }
  };
  /**
   * Opens the cookie policy modal for non ko-KR, ja-JP, and en-US locales.
   * Requires 2 divs with ids:
   * - optanon-cookie-policy-holder
   * - optanon-cookie-policy
   * The #optanon-cookie-policy is inserted in the `addOneTrustScript` method.
   */


  var hydrateCookiePolicyModal = function hydrateCookiePolicyModal() {
    var movePolicy = setTimeout(function () {
      var clonedCookiePolicy = document.getElementById(cookiePolicyId).cloneNode(true);
      document.getElementById('optanon-cookie-policy-holder').appendChild(clonedCookiePolicy);
      clonedCookiePolicy.style.display = 'block';
      clearInterval(movePolicy);
    }, 100);
  };

  (0, _react.useEffect)(function () {
    addOneTrustScript();
  }, [dataDomainScript, locale, view, webview]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    hydrateCookiePolicyModal: hydrateCookiePolicyModal
  };
};

exports.useOneTrust = useOneTrust;